module.exports = __webpack_public_path__ + "static/media/culture_vision.b5edb755.png";